import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { RegraEstabelecimento, SalvarRegraEstabelecimentoPayload } from './regra-estabelecimento.model';

@Injectable({ providedIn: 'root' })
export class RegraEstabelecimentoService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<RegraEstabelecimento[]>> {
    return this.http.get<ApiResponse<RegraEstabelecimento[]>>(`${this.url}/${nrSeqCupom}/regra-estabelecimento`);
  }

  criar(nrSeqCupom: number, payload: SalvarRegraEstabelecimentoPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/regra-estabelecimento`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/regra-estabelecimento/${nrSequencia}`);
  }
}
